import React from 'react';

import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { useDispatch } from 'react-redux';

import { DeleteOutlined } from '@ant-design/icons';

import RibbonButton from 'common/components/button/RibbonButton';
import { dialogFunction, CustomNotification } from 'common/components';

import * as productActions from 'pages/product-full-view/controllers/actions';

import { useProductHierarchies, useProductFullView } from 'hooks';
import { useGetToleranceProductId } from 'pages/product-full-view/hooks';
import { useQueryProductHierarchyShortDetail } from 'pages/product-full-view/queries';

import Messages from 'i18n/messages/home';

import { useGetCurrentProductHierarchyDetails } from 'pages/product-full-view/hooks';

const DeleteHierarchy = (props) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const { id: productId } = useParams();

  const { selectedHierarchy, sectionDisabled } = props;

  const { productFull } = useProductFullView({ productId });
  const { deleteHierarchiesMutation } = useProductHierarchies({
    productId: productFull?.productId,
  });

  const toleranceProductId = useGetToleranceProductId();

  const { invalidateProductHierarchyShortDetail } =
    useQueryProductHierarchyShortDetail();

  const {
    data: currentHierarchyShortDetails,
    invalidateProductHierarchyDetails,
  } = useGetCurrentProductHierarchyDetails();

  const loading = deleteHierarchiesMutation.isLoading;

  const showDeleteConfirmDialog = () => {
    dialogFunction({
      type: 'warn',
      okButtonProps: {
        loading: loading,
      },
      content: intl.formatMessage(Messages.deleteHierarchyMessage),
      onOk: callApiDeleteHierarchy,
    });
  };

  const callApiDeleteHierarchy = () => {
    const successMessage = intl.formatMessage(Messages.deleteHierarchySuccess);
    const errorMessage = intl.formatMessage(Messages.deleteHierarchyError);

    const params = {
      hierarchyId: selectedHierarchy?.productHierarchyId,
    };

    deleteHierarchiesMutation.mutate(params, {
      onSuccess: ({ isSuccess }) => {
        if (!isSuccess) CustomNotification.error(errorMessage);

        CustomNotification.success(successMessage);
        dispatch(productActions.updateSelectedHierarchy(null));
        dispatch(productActions.updateHierarchyEndpoint(null));
        //* reload hierarchies in drawer
        invalidateProductHierarchyDetails(
          currentHierarchyShortDetails?.hierarchyId
        );

        //* reload hierarchy dropdown in product header
        invalidateProductHierarchyShortDetail(productId);
      },
      onError: () => {
        CustomNotification.error(errorMessage);
      },
    });
  };

  const onClickHandler = () => {
    showDeleteConfirmDialog();
  };

  const isDisabled = !selectedHierarchy || sectionDisabled;

  return (
    <>
      <RibbonButton
        size='small'
        className='button-item-dropdown'
        icon={<DeleteOutlined style={{ height: 26 }} />}
        label={Messages.deleteHierarchy}
        onClick={onClickHandler}
        disabled={isDisabled}
      />
    </>
  );
};

export default DeleteHierarchy;
